import React from 'react';
import { connect } from 'react-redux';
import Layout from '../../Components/Layout';
import { closePanel } from '../../Redux/Panels/RightPanel/actions';

const MedicalHistory = () => {
    const RECORDS = [{},{},{},{},{},{},{}]
    return (
        <Layout sidePanel={true} title={"Medical Reports"}>
    {/* Status */}
    <div className="status-page-wrapper mx-0 w-100">
    {/*Status header*/}
    <div className="head">
        <a className="logo" href="/">
        <img className="light-image" src="https://huro.cssninja.io/assets/img/logos/logo/logo.svg" alt />
        <img className="dark-image" src="https://huro.cssninja.io/assets/img/logos/logo/logo-light.svg" alt />
        </a>
        <a className="action-link" onclick="goBack()">Take me Back</a>
    </div>
    {/*Status body*/}
    <div className="status-block">
        <div className="status-header">
        <div className="indicator" />
        <div className="title is-4">All services are online.</div>
        <div className="subtitle is-6">As of September 20, 2020 at 11:08 PM PST.</div>
        </div>
        <div className="status-uptime">
        <div className="title">Services</div>
        <div className="uptime">Uptime of the past 90 days</div>
        </div>
        <div className="status-list">
        {/*Status item*/}
        {RECORDS.map((e, i) => {
            return (
                <>
                <div className="list-block">
                        <div className="icon-wrap">
                        <img src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/animaticons/lightbulb.gif" alt />
                        </div>

                        <div class="subtitle">
                        <p class="light-text">Get familiar with the Huro button styles. Code
                                                            examples included.</p>
                        </div>
                        <div className="progress-wrap">
                        <div className="progress-wrap-inner">
                            <div>
                            <div className="label dark-inverted">REST API</div>
                            <p>Sorry about that! Our systems are showing everything as caught up now. Let us
                                        know if you're still seeing problems!</p>
                            </div>
                            <div className="amount has-text-centered">
                            <span>99%</span>
                            </div>
                        </div>
                        {/* <progress className="progress is-primary is-smaller" value={99} max={100}>99%</progress> */}
                        </div>
                    </div>
                    {i < RECORDS.length - 1 && <hr/>}
                </>
            )
        })}
       
        </div>
    </div>
    <div className="status-block">
        <div className="tweets-header">
        <div className="icon">
            <i aria-hidden="true" className="fab fa-twitter" />
        </div>
        <div className="username dark-inverted">
            <span>@cssninjaStudio</span>
        </div>
        <a className="action-link">View on Twitter</a>
        </div>
        <div className="status-tweets">
        <div className="updates">
            <div className="update">
            <div className="h-avatar">
                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/logos/logo/hanzo.svg" alt />
                <img className="badge" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/icons/stacks/html5.svg" alt />
            </div>
            <div className="update-content">
                <div className="timestamp">July 29 at 5:39pm</div>
                <div className="tweet">We're experiencing higher than normal load on our batch infrastructure.
                Webhooks
                are about an hour delayed. API calls are not impacted</div>
            </div>
            </div>
            <div className="update">
            <div className="h-avatar">
                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/logos/logo/hanzo.svg" alt />
                <img className="badge" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/icons/stacks/html5.svg" alt />
            </div>
            <div className="update-content">
                <div className="timestamp">July 23 at 9:21pm</div>
                <div className="tweet">Sorry about that! Our systems are showing everything as caught up now. Let us
                know if you're still seeing problems!</div>
            </div>
            </div>
        </div>
        </div>
    </div>
    <div className="status-footer">
        <div>
        <a href="#">Legal</a>
        <a href="#">About</a>
        <a href="#">Jobs</a>
        </div>
        <div className="copyright">
        <span>© 2020-2021 Css Ninja</span>
        </div>
    </div>
    </div>

        </Layout>
    )
}


const mapStateToProps = (state) => {
	return { user: state.user.user, dashboard: state.dashboard };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalHistory);
